/* eslint-disable no-console */
import { Codes, Dto } from '@lmc/ts-common/lib/utils/errors'
import * as Sentry from '@sentry/react'
import CONSTANTS from 'utils/constants'
import { getQueryParams } from 'utils/getQueryParams'
import store from '../../store'
import Actions from '../../actions'
import { getHomeChangedModalOpen, setHomeChangedModalOpen } from './homeSwitchBroadcast'

const isBrowserEnv = (): boolean => {
  if (window) {
    return true
  }

  return false
}

const checkIfBrowser = () => {
  const isBrowser: boolean = isBrowserEnv()

  if (!isBrowser) {
    throw new Error('This is not a browser env')
  }
}

const ssoLogin = async () => {
  const redirectUri = `${window.location.origin}${window.location.pathname}`

  const params = {
    client_id: CONSTANTS.VITE_FUSIONAUTH_APP_CO_CLIENT_ID,
    redirectUri,
    scope: 'offline_access',
  }

  const queryParams = getQueryParams(params)

  checkIfBrowser()

  window.location.href = `${CONSTANTS.VITE_API_CM_URL_PROXY}/v5/auth/login?${queryParams}`
}

export const ssoLogout = async () => {
  Sentry.setUser(null)

  checkIfBrowser()

  window.location.href = `${
    CONSTANTS.VITE_APP_CM_API
  }/auth/logout?${new URLSearchParams({
    client_id: CONSTANTS.VITE_FUSIONAUTH_APP_CO_CLIENT_ID,
  })}`
}

export const ssoMiddleware = async (response: Response) => {
  if (response.status === 401) {
    await ssoLogin()
  }
}

export const resetHomeChangedModalGuard = () => {
  setHomeChangedModalOpen(false)
}

export class HomeChangedError extends Error {}

export const homeChangedMiddleware = async (response: Response) => {
  if (response.status !== 409) return

  let body: any
  try {
    body = await response.clone().json()
  } catch {
    return
  }
  if (body?.code !== 'HOME_CHANGED') return

  if (getHomeChangedModalOpen()) throw new HomeChangedError()
  setHomeChangedModalOpen(true)

  const action = Actions.openModal({
    modalId: 'homeChangedModal',
    data: {
      currentHomeName: body.currentHome?.name,
      requestedHomeId: body.requestedHome?.id,
    },
  })
  // @ts-ignore untyped Redux store
  store.dispatch(action)

  throw new HomeChangedError()
}

export const checkMFAForce = async (response: Dto) => {
  if (
    response.code === Codes.mfaIsMissingWhenFeatureIsEnabled &&
    window.location.pathname !== '/mfa'
  ) {
    window.location.replace('/mfa')
  }
}
